module.exports = __webpack_public_path__ + "media/images/element/06-9ac233de7f8149266460308a9b88152c.png";